export enum EEntreeZoneType {
    Oui = 1,
    Non = 2,
    NA = 3,
    Sas = 4,
}